import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {styled} from '@mui/material/styles';
import CartNum from './CartNum/CartNum';
import classes from './Cart.module.css';
import {useState, useEffect} from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import {connect} from 'react-redux';
import globalactions from '../../Redux/actions/global';
import CloseIcon from '@mui/icons-material/Close';
import Logo from '../../Components/Logo/Logo';
import {Link} from 'react-router-dom';
import URLS from '../../URLS';
import image from '../../Designs/1.jpg';

const mapDispatchToProps = dispatch => ({
	updateCart: (item, quantity) => dispatch(globalactions.updateCart(item, quantity)),
	addToCart: (item, quantity) => dispatch(globalactions.addToCart(item, quantity)),
	eliminateItem: item => dispatch(globalactions.eliminateItem(item)),
});

const mapStoreToProps = state => ({
	cart: JSON.parse(localStorage.getItem("cart")) || state.changeCart,
	products: JSON.parse(localStorage.getItem("products")) || state.changeProducts,
});

const Cart = ({cart,
							 nStyles,
							 cStyles,
							 addToCart,
							 updateCart,
							 products,
							 eliminateItem,
							 containerClass}) => {
	const ShoppingCart = styled(ShoppingCartIcon)(({theme}) => ({...cStyles}));

	const [showCart, setShowCart] = useState(false);
	const [showDrop, setShowDrop] = useState(false);

	const getInfo = (db, item) => {
		let productInfo = db.filter(({title}) => item===title)[0];
		if (typeof(productInfo) === 'undefined') {
			productInfo = {
				title: item,
				price: 0,
				category: "",
				subcategory: "",
				description: "",
				link: ""
			}
		}
		return productInfo;
	}

	return (
		<div className={`${classes.container} ${containerClass}`}>
			<CartNum style={{
				alignSelf: 'right',
				position: 'absolute',
				marginLeft: '45px',
				marginBottom: '25px',
				...nStyles
			}} num={cart[1]}/>
			<ShoppingCart onClick={()=>{
					if (cart[1]>0) {
						setShowCart(true);
					}
				}} onMouseOver={()=>{
					if (cart[1]===0) {
						setShowDrop(true);
					}
				}} onMouseLeave={()=>{
					if (cart[1]===0) {
						setShowDrop(false);
					}
				}}/>
			{
				cart[1]>0 ?
				<SwipeableDrawer anchor={"right"}
												 open={showCart}
												 onOpen={()=>setShowCart(true)}
												 onClose={()=>setShowCart(false)}>
												 <div className={classes.cart}>
													 <div>
														 <CloseIcon onClick={()=>setShowCart(false)} sx={{
																 cursor: "pointer"
															 }}/>
														 <h4>Valentina</h4>
													 </div>
													 <div className={classes.items}>
														 {
															 cart[0].map(({item, quantity}, indx) => {
																 const productInfo = getInfo(products, item);
																 return <div className={classes.item} key={indx}>
																	<div>
																		<img src={image}/>
																		<div>
																			<p className={classes.itemTitle}>{item}</p>
																			<p className={classes.itemCategory}>{productInfo.category} & {productInfo.subcategory}</p>
																			<div className={classes.itemAdder}>
																				<p onClick={
																						()=>{
																							if (quantity===1) {
																								eliminateItem(item);
																							} else {
																								updateCart(item, quantity-1);
																							}
																						}
																					}>-</p>
																				<p>{quantity}</p>
																				<p onClick={()=>{
																						updateCart(item, quantity+1);
																					}}>+</p>
																			</div>
																		</div>
																	</div>
																	<div>
																		<span
																			onClick={() => {
																				eliminateItem(item);
																			}}
																			style={{
																				cursor: 'pointer'
																			}}
																			className={classes.itemEliminateContainer}>
																			<CloseIcon sx={{
																					fontSize: '18px',
																				}}/>
																		</span>
																		<p className={classes.itemPrice}>S/{productInfo.price*quantity}</p>
																	</div>
																</div>
															 })
														 }
													 </div>
													 <div>
														 <div>
															 <p>Subtotal</p>
															 <p>S/{
																	 cart[0].reduce((curr, {item, quantity}) => {
																		 const productInfo = getInfo(products, item);
																		 return curr + (productInfo.price*quantity);
																	 }, 0)
																 }</p>
														 </div>
														 <a href={`https://pasteleriavalentina.netlify.app/${URLS.CHECKOUT}`}>
															 Realiza Su Pedido
														 </a>
													 </div>
												 </div>
				</SwipeableDrawer> :
				<div className={`${classes.dropdown} ${showDrop ? 'slide-cart-dropdown' : ''}`}>
					<p>No hay productos en el carrito</p>
				</div>
			}

		</div>
	);
};

export default connect(mapStoreToProps, mapDispatchToProps)(Cart);
